import { NJTab } from '@engie-group/fluid-design-system-react';
import { useState, useEffect } from 'react';
import { Flex } from "antd";
import './AdminDashboard.css';
import HeaderMenu from './components/HeaderMenu';
import FooterEngie from './components/Footer'
import { useUser } from './context/UserContext';
import AdminPrompt from './components/Admin/AdminPrompt';
import AdminData from './components/Admin/AdminData';
import AdminTermsConditions from './components/Admin/AdminTermsConditions';
import AdminFeedback from './components/Admin/AdminFeedback';
import AdminUsers from './components/Admin/AdminUsers';
import AdminAnalyze from './components/Admin/AdminAnalyze';
import { useReferentials } from './context/ReferentialsContext';
import { oktaEnabled } from './config';


const AdminDashboard = () => {

    const { referentials } = useReferentials();
    const userInfo = useUser();

    const [activeTab, setActiveTab] = useState('adminanalyze');
    const [enableAdmin, setEnableAdmin] = useState(false);

    useEffect(() => {

        // Enable admin menu if running on localhost or if okta is disabled
        if ((window.location.hostname === 'localhost') || !oktaEnabled) {
            setEnableAdmin(true);
        } else {
            let username = userInfo?.preferred_username;
            if (username && referentials?.admin && userInfo) {
                let gid = username.split('@')[0].toUpperCase();
                setEnableAdmin(referentials.admin.includes(gid));
            }
        }
    }, [referentials, userInfo]);


    return (
        <>
            <div className='sizelimit-outer'>
                <div className='sizelimit-inner sizelimit-max-width'>
                    <div className="dashboard-container">
                        <Flex vertical={true} justify='space-between' style={{ height: '100%' }}>
                            <div>
                                <div className="dashboard-header">
                                    <HeaderMenu
                                        activeItemId='admin'
                                        username={userInfo?.name}
                                    />
                                </div>
                                {enableAdmin &&
                                    <div className='nj-tab admin-dashboard-tab'>
                                        <div className='nj-tab__items' role='tablist'>
                                            <NJTab
                                                id="adminanalyze"
                                                label="Generation Analysis"
                                                isActive={activeTab === 'adminanalyze'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('adminanalyze')}
                                            />
                                            <NJTab
                                                id="data"
                                                label="Expectations"
                                                isActive={activeTab === 'Expectations'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('Expectations')}
                                            />
                                            <NJTab
                                                id="evp"
                                                label="EVP"
                                                isActive={activeTab === 'EVP'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('EVP')}
                                            />
                                            <NJTab
                                                id="naration"
                                                label="Narration"
                                                isActive={activeTab === 'Narration'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('Narration')}
                                            />
                                            <NJTab
                                                id="filters"
                                                label="Filters"
                                                isActive={activeTab === 'Filters'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('Filters')}
                                            />
                                            <NJTab
                                                id="prompt"
                                                label="System prompts"
                                                isActive={activeTab === 'prompt'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('prompt')}
                                            />
                                            <NJTab
                                                id="terms"
                                                label="Terms & Conditions"
                                                isActive={activeTab === 'terms'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('terms')}
                                            />
                                            <NJTab
                                                id="feedback"
                                                label="Feedback"
                                                isActive={activeTab === 'feedback'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('feedback')}
                                            />
                                            <NJTab
                                                id="adminusers"
                                                label="Admin Users"
                                                isActive={activeTab === 'adminusers'}
                                                isDisabled={false}
                                                onClick={() => setActiveTab('adminusers')}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                            {enableAdmin &&
                                <div className='admin-dashboard-content'>
                                    <div className='admin-dashboard-module'>
                                        {activeTab === 'prompt' &&
                                            <AdminPrompt
                                                active={activeTab === 'prompt'}
                                            />}
                                        {activeTab === 'Expectations' &&
                                            <AdminData
                                                active={activeTab === 'Expectations'}
                                                dataType='Expectations'
                                            />}
                                        {activeTab === 'EVP' &&
                                            <AdminData
                                                active={activeTab === 'EVP'}
                                                dataType='EVP'
                                            />}
                                        {activeTab === 'Narration' &&
                                            <AdminData
                                                active={activeTab === 'Narration'}
                                                dataType='Narration'
                                            />}
                                        {activeTab === 'Filters' &&
                                            <AdminData
                                                active={activeTab === 'Filters'}
                                                dataType='Filters'
                                                keyValuesMode={true}
                                            />}
                                        {activeTab === 'terms' &&
                                            <AdminTermsConditions
                                                active={activeTab === 'terms'}
                                            />}
                                        {activeTab === 'feedback' &&
                                            <AdminFeedback
                                                active={activeTab === 'feedback'}
                                            />}
                                        {activeTab === 'adminusers' &&
                                            <AdminUsers
                                                active={activeTab === 'adminusers'}
                                            />}
                                        {activeTab === 'adminanalyze' &&
                                            <AdminAnalyze
                                                active={activeTab === 'adminanalyze'}
                                            />}
                                    </div>
                                </div>
                            }
                            {!enableAdmin &&
                                <div>
                                    You are not authorized to access this page.
                                </div>}
                            <FooterEngie />
                        </Flex>
                    </div>
                </div>
            </div >
        </>
    )
}

export default AdminDashboard;
